export default {
  'Enter a promo code! First limit people receive amount coins':
    'Introduceți un cod promoțional! Primii utilizatori vor câștiga {{</amount>}} (de) monede',
};
